<!--坏件出库审核弹窗-->
<template>
  <div>
    <el-dialog :visible.sync="dialogVisible"
               custom-class="max-dialog"
               center
               :close-on-click-modal="false"
               append-to-body>
      <div slot="title" style="display:flex;align-items:center;justify-content:center;gap:10px;">
        <span>坏件出库审核 - {{controlData.displayErpserial || controlData.erpserial}}</span>
        <el-tag type="warning" size="small">待审核</el-tag>
      </div>
      <!--顶部信息区-->
      <div style="width:100%;margin-bottom:10px;">
        <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;" class="print-table">
          <tr class="noborder">
            <td align="left" style="width:90px;">出库单号：</td>
            <td>{{controlData.displayErpserial || controlData.erpserial}}</td>
            <td align="left" style="width:90px;">处理方式：</td>
            <td>{{handlemode}}</td>
            <td align="left" style="width:90px;">仓库：</td>
            <td>{{controlData.cangkuname}}</td>
          </tr>
          <tr class="noborder" v-if="handlemode === '退回供应商'">
            <td align="left">供应商：</td>
            <td>{{pcustomer}}</td>
            <td align="left">快递单号：</td>
            <td colspan="3">{{logisticsnum}}</td>
          </tr>
          <tr class="noborder" v-if="controlData.remark">
            <td align="left">备注：</td>
            <td colspan="5">{{controlData.remark}}</td>
          </tr>
          <tr class="noborder">
            <td align="left">提交人：</td>
            <td>{{controlData.uname}}</td>
            <td align="left">提交时间：</td>
            <td colspan="3">{{controlData.adddate}}</td>
          </tr>
        </table>
      </div>
      <!--明细表格区-->
      <div style="width:100%;">
        <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;" class="query-table">
          <tr>
            <td style="text-align:center;">坏件入库单号</td>
            <td style="text-align:center;">销售单号</td>
            <td style="text-align:center;">采购单号</td>
            <td style="text-align:center;">名称</td>
            <td style="text-align:center;">编码</td>
            <td style="text-align:center;">规格</td>
            <td style="text-align:center;">责任人</td>
            <td style="text-align:center;">类别</td>
            <td style="text-align:center;">原因</td>
            <td style="text-align:center;">入库时间</td>
            <td style="text-align:center;">仓库</td>
            <td style="text-align:center;">录入人</td>
            <td style="text-align:center;">数量</td>
          </tr>
          <tr v-for="item in tableData" :key="item.unitguid">
            <td style="text-align:center;">
              <span v-if="item.inboundserial" @click="lookInbound(item)" style="cursor:pointer;font-weight:bold;">{{item.inboundserial}}</span>
            </td>
            <td style="text-align:center;">
              <span v-if="item.ordernum" @click="lookdingdan(item)" style="cursor:pointer;font-weight:bold;">{{item.ordernum}}</span>
            </td>
            <td style="text-align:center;">{{item.buyordernum}}</td>
            <td style="text-align:left;">{{item.seedname}}<p v-if="item.subseedname" style="padding-left:20px;">{{item.subseedname}}</p></td>
            <td style="text-align:center;">{{item.seedcode}}</td>
            <td style="text-align:center;">{{getPackagesize(item.packagesize)}}</td>
            <td style="text-align:center;">{{item.customername}}</td>
            <td style="text-align:center;">{{item.ordername}}</td>
            <td style="text-align:left;">{{item.remark}}</td>
            <td style="text-align:center;">{{item.accdate}}</td>
            <td style="text-align:center;">{{item.cangkuname}}</td>
            <td style="text-align:center;">{{item.uname}}</td>
            <td style="text-align:center;">{{item.totalnumber}}</td>
          </tr>
          <tr>
            <td colspan="12" style="text-align:right;font-weight:bold;">合计：</td>
            <td style="text-align:center;font-weight:bold;">{{totalQuantity}}</td>
          </tr>
        </table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
        <el-button type="danger" @click="handleReject" :loading="loading" v-if="hasAuditRight">驳 回</el-button>
        <el-button type="success" @click="handleApprove" :loading="loading" v-if="hasAuditRight">通 过</el-button>
      </div>
    </el-dialog>
    <!--驳回原因弹窗-->
    <el-dialog title="驳回原因" :visible.sync="rejectDialogVisible" width="400px" append-to-body :close-on-click-modal="false">
      <el-input type="textarea" v-model="rejectReason" :rows="3" placeholder="请输入驳回原因（选填）"></el-input>
      <span slot="footer">
        <el-button @click="rejectDialogVisible = false">取 消</el-button>
        <el-button type="danger" @click="confirmReject" :loading="loading">确认驳回</el-button>
      </span>
    </el-dialog>
    <BaoSunDetail ref="BaoSunDetail"></BaoSunDetail>
    <CstagreementEdit ref="DataContactEdit"></CstagreementEdit>
  </div>
</template>

<script>
  import {getByERPSerial} from '@/api/set/jxcstoreform'
  import {badpartsauditapprove, badpartsauditreject} from '@/api/set/warehouse'
  import BaoSunDetail from '../testorder/cstagreement/BaoSunDetail'
  import CstagreementEdit from '@/components/testorder/cstagreement/CstagreementEdit'

  export default {
    name: 'StorageBadAudit',
    components: {
      BaoSunDetail,
      CstagreementEdit
    },
    data() {
      return {
        dialogVisible: false,
        rejectDialogVisible: false,
        controlData: {},
        tableData: [],
        handlemode: '',
        pcustomer: '',
        logisticsnum: '',
        rejectReason: '',
        loading: false,
        hasAuditRight: false
      }
    },
    computed: {
      totalQuantity() {
        return this.tableData.reduce((sum, item) => sum + (Number(item.totalnumber) || 0), 0)
      }
    },
    methods: {
      show(erpserial) {
        this.controlData = {}
        this.tableData = []
        this.handlemode = ''
        this.pcustomer = ''
        this.logisticsnum = ''
        this.rejectReason = ''
        this.dialogVisible = true

        this.hasAuditRight = this.$checkRight('坏件库审核')

        getByERPSerial({erpserial: erpserial, isout: '1'}).then(response => {
          if (response.data.code == 0) {
            this.controlData = response.data.main || {}
            this.tableData = response.data.list || []
            this.handlemode = response.data.handlemode || ''
            this.pcustomer = response.data.pcustomer || ''
            this.logisticsnum = response.data.logisticsnum || ''
          }
        })
      },
      lookInbound(item) {
        if (item.inboundserial) {
          this.$refs.BaoSunDetail.show(item.inboundserial, false)
        }
      },
      lookdingdan(item) {
        if (item.ordernum) {
          this.$refs.DataContactEdit.initData({erpserial: item.ordernum})
          this.$refs.DataContactEdit.show()
        }
      },
      handleApprove() {
        this.$confirm('确认通过此出库申请？', '审核通过', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'success'
        }).then(() => {
          this.loading = true
          badpartsauditapprove({erpserial: this.controlData.erpserial}).then(response => {
            this.loading = false
            if (response.data.code == 0) {
              this.$message({message: '审核通过，已生成出库单：' + response.data.erpserial, type: 'success'})
              this.dialogVisible = false
              this.$emit('bindGrid')
            } else {
              this.$message({message: response.data.msg || '操作失败', type: 'error'})
            }
          }).catch(() => { this.loading = false })
        }).catch(() => {})
      },
      handleReject() {
        this.rejectDialogVisible = true
      },
      confirmReject() {
        this.loading = true
        badpartsauditreject({
          erpserial: this.controlData.erpserial,
          rejectReason: this.rejectReason
        }).then(response => {
          this.loading = false
          if (response.data.code == 0) {
            this.$message({message: '已驳回', type: 'success'})
            this.rejectDialogVisible = false
            this.dialogVisible = false
            this.$emit('bindGrid')
          } else {
            this.$message({message: response.data.msg || '操作失败', type: 'error'})
          }
        }).catch(() => { this.loading = false })
      },
      getPackagesize(packagesize) {
        if (!packagesize) return ''
        try {
          let temp = JSON.parse(packagesize)
          if (temp.M) {
            return temp.M + '-' + (temp.C || '')
          } else {
            let s = 'S:' + (parseFloat(temp.Y) > 0 ? '+' + temp.Y : temp.Y) + ',C:' + (parseFloat(temp.X) > 0 ? '+' + temp.X : temp.X)
            if (temp.type) s = temp.type + ' ' + s
            return s
          }
        } catch (e) { return packagesize }
      }
    }
  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }
  .query-table td.content {
    text-align: center;
  }
  .noborder td {
    border: none;
    font-size: 12px;
    padding: 4px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/warehouse/StorageBadAudit.vue